import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Characters extends Component {
	
	constructor(props) {
		super(props);
		this.state = {characters: {}, sorted: false};
		this.addCharacter = this.addCharacter.bind(this);
		this.updateCharacter = this.updateCharacter.bind(this);
		this.update = this.update.bind(this);
		this.sortCharacters = this.sortCharacters.bind(this);
	}
	
	componentDidMount() {
		var obj = this;
		Ajax.getCharacters().then(function(characters) {
			var keysSorted = Object.keys(characters).sort(
				function(a, b) {
					return (characters[a]["player"].toLowerCase() < characters[b]["player"].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({characters: characters, sorted: keysSorted});
		});
	}
	
	sortCharacters(field) {
		var obj = this;
		return function(event) {
			var list = obj.state.characters;
			var keysSorted = Object.keys(list).sort(
				function(a, b) {
					if (field === "level") {
						return (Number(list[a][field]) < Number(list[b][field]) ? -1 : 1);	
					} else {
						return (list[a][field].toLowerCase() < list[b][field].toLowerCase() ? -1 : 1);	
					}					
				}
			);
			obj.setState({sorted: keysSorted});
		}
	}
	
	update(characters) {
		var obj = this;
		Ajax.postCharacters(characters).then(function () {
			obj.setState({characters: characters});
		});		
	}
	
	addCharacter(event) {
		var obj = this;
		Ajax.getCharacters().then(function (characters) {
			var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
			
			var character = {
				player: "",
				characterName: "",			
				race: "",
				sex: "",
				level: "",
				classes: "",
				state: ""
			}
			characters[id] = character;	
			var keysSorted = Object.keys(characters).sort(
					function(a, b) {
						return (characters[a]["player"].toLowerCase() < characters[b]["player"].toLowerCase() ? -1 : 1);
					}
				);

			obj.setState({characters: characters, sorted: keysSorted});
			obj.update(characters);
		});		
	}
	
	updateCharacter(id) {
		var obj = this;
		
		return function(event) {
			Ajax.getCharacters().then(function (characters) {
				var el = $("#" + id);
				var player = $(".PlayerName", el).first()[0].innerHTML;
				var characterName = $(".CharacterName", el).first()[0].innerHTML;
				var race = $(".CharacterRace", el).first()[0].innerHTML;
				var sex = $(".CharacterSex", el).first()[0].innerHTML;
				var level = $(".CharacterLevel", el).first()[0].innerHTML;
				var classes = $(".CharacterClass", el).first()[0].innerHTML;
				var state = $(".CharacterStatus", el).first()[0].innerHTML;
				var character = {
					player: player,
					characterName: characterName,			
					race: race,
					sex: sex,
					level: level,
					classes: classes,
					state: state
				}
				
				characters[id] = character;
				obj.setState({characters: characters});
				obj.update(characters);
			});
		};
	}
	
	render() {
		var characters = this.state.characters;
		var sorted = this.state.sorted;
		var obj = this;
		
		return (
		<div className="Characters">			
			<div className="AddSymbol" onClick={this.addCharacter}><FontAwesomeIcon icon="user-plus"/></div>
			<div className="CharactersList">				
				<div className="CharactersListHeaders">					
					<div className="CharactersListHeader PlayerName" onClick={this.sortCharacters("player")}>Joueur</div>
					<div className="CharactersListHeader CharacterName" onClick={this.sortCharacters("characterName")}>Perso</div>
					<div className="CharactersListHeader CharacterRace" onClick={this.sortCharacters("race")}>Race</div>
					<div className="CharactersListHeader CharacterSex" onClick={this.sortCharacters("sex")}>Sexe</div>
					<div className="CharactersListHeader CharacterLevel" onClick={this.sortCharacters("level")}>Niveau</div>
					<div className="CharactersListHeader CharacterClass" onClick={this.sortCharacters("classes")}>Classe(s)</div>
					<div className="CharactersListHeader CharacterStatus" onClick={this.sortCharacters("state")}>Statut</div>
				</div>
				
				
				{characters && sorted ? 
				
				sorted.map(function(key, idx) {
					var character = characters[key];
					return (
					<div id={key} key={idx} className="Character">
						<div className="CharacterField PlayerName single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.player}}></div>
						<div className="CharacterField CharacterName single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.characterName}}></div>
						<div className="CharacterField CharacterRace single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.race}}></div>
						<div className="CharacterField CharacterSex single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.sex}}></div>
						<div className="CharacterField CharacterLevel single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.level}}></div>
						<div className="CharacterField CharacterClass single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.classes}}></div>
						<div className={"CharacterField CharacterStatus single-line " + character.state }  contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.state}}></div>
					</div>
					)
				}): null
				}
			</div>
		</div>
		);
	}
}

export default Characters;
